<script lang="ts">
  import clsx from 'clsx';
  import BaseHeading from '../BaseHeading/BaseHeading.svelte';
  import type { HeadingLargeProps } from './types';
  let { class: className, size = 'large', ...props }: HeadingLargeProps = $props();
</script>

<BaseHeading class={clsx(className)} level={1} {size} {...props} />
